import React, { useEffect, useState } from "react";
import unsplash from "../api/unsplash";
import GlobalSnackbar from "./Snackbar";
import LinearProgress from "@mui/material/LinearProgress";

import {
  Grid,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  ButtonGroup,
  Zoom,
  DialogActions,
  DialogContentText,
  Autocomplete,
  InputAdornment,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import { IconButton } from "@mui/material";

import {
  DataGridPro,
  itIT,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";

import { Add, Delete, Close, Check } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

export const KpiParita = () => {
  const [kpiParita, KpiParita] = useState([]);
  const [loading, setLoading] = useState(true);
  const [kpiSelezionata, setKpiSelezionata] = useState([]);

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const columns = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Azioni",
      hide: false,
      width: "130",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <IconButton
            aria-label="edit"
            onClick={async () => {
              await setKpiSelezionata(params.row);
              document.getElementById("edit").click();
              handleClickOpen();
            }}
          >
            <EditIcon
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton>

          {/* <DeleteDialog kpi={params.row} myFunction={handleDelete} /> */}
        </>
      ),
    },
    {
      field: "Lettera",
      headerName: "Lettera",
      width: 70,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "Descrizione",
      headerName: "Etichetta",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "ContrattoIndeterminato",
      headerName: "Contratto Indeterminato",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.row.ContrattoIndeterminato ? (
          <>{params.row.ContrattoIndeterminato}%</>
        ) : (
          ""
        ),
    },
    {
      field: "Dirigenti",
      headerName: "Dirigenti",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.row.Dirigenti ? <>{params.row.Dirigenti}%</> : "",
    },
    {
      field: "DifferenzialeRetributivo",
      headerName: "Differenziale Retributivo",
      width: 70,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.row.DifferenzialeRetributivo ? (
          <>{params.row.DifferenzialeRetributivo}%</>
        ) : (
          ""
        ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const reloadAfterUpload = async () => {
    let response = await unsplash.get("kpiParita", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    });

    KpiParita(response.data.data);
  };

  const handleSave = async (kpi, operazione) => {
    if (operazione === "new") {
      try {
        await unsplash.post(
          "kpiParita",
          {
            kpi: kpi,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );
        setSnack({
          severity: "success",
          messaggio: "CCNL creato con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante la creazione",
        });
        setOpenSnack(true);
      }
      handleClose();
    } else {
      try {
        await unsplash.put(
          "kpiParita",
          { kpi: kpi },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );
        setSnack({
          severity: "success",
          messaggio: "CCNL aggiornato con successo",
        });
        setOpenSnack(true);

        reloadAfterUpload();
      } catch {
        setSnack({
          severity: "error",
          messaggio: "Errore durante l'aggiornamento",
        });
        setOpenSnack(true);
      }
      handleClose();
    }
  };

  const handleDelete = async (kpi) => {
    try {
      await unsplash.delete("kpiParita", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        data: {
          id: kpi,
        },
      });

      setSnack({
        severity: "success",
        messaggio: "CCNL eliminata con successo",
      });
      setOpenSnack(true);
      reloadAfterUpload();
    } catch {
      setSnack({
        severity: "error",
        messaggio: "Errore durante l'eliminazione dei CCNL",
      });
      setOpenSnack(true);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
        </Grid>
      </GridToolbarContainer>
    );
  }

  useEffect(() => {
    (async () => {
      try {
        let response = await unsplash.get("kpiParita", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });
        KpiParita(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error(error.message);
      }
    })();
  }, []);

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Grid item xs={12}>
        <Card>
          <CardContent sx={{ p: { xs: 0 } }}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Grid item xs={12} md={4}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        justifyContent="flex-end"
                      >
                        <Kpi
                          id="edit"
                          kpi={kpiSelezionata}
                          saveFunction={handleSave}
                          title="Modifica CCNL"
                        />
                        {/* <Kpi
                          id="new"
                          kpi={kpiSelezionata}
                          saveFunction={handleSave}
                          title="Nuova CCNL"
                        /> */}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      height: { xs: "75vh", md: "60vh", xl: "75vh" },
                      width: 1,
                    }}
                  >
                    <DataGridPro
                      initialState={{
                        pinnedColumns: { left: ["Actions"] },
                      }}
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                      }}
                      slots={{
                        loadingOverlay: LinearProgress,
                      }}
                      loading={loading}
                      localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                      }
                      rowHeight={52}
                      rows={kpiParita}
                      columns={columns}
                      getRowId={(row) => row.ID}
                      pageSize={20}
                      rowsPerPageOptions={[20]}
                      disableSelectionOnClick
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

/* Creazione Nuovi Formatori */
const Kpi = (props) => {
  const [open, setOpen] = useState(false);
  const [gruppi, setGruppi] = useState([]);
  const [gruppiSel, setGruppiSel] = useState(null);
  const [livelli, setLivelli] = useState([]);
  const [livelliSel, setLivelliSel] = useState(null);
  const [kpi, setKpi] = useState({
    Descrizione: "",
    IDGruppo: 0,
    IDLivello: 0,
  });

  const handleClickOpen = async () => {
    if (props.id === "edit") {
      setKpi(props.kpi);
    }
    setOpen(true);
  };
  const handleClose = () => {
    setKpi({ Descrizione: "", IDGruppo: 0, IDLivello: 0 });
    setGruppiSel(null);
    setLivelliSel(null);
    setOpen(false);
  };
  const handleChange = (e) => {
    let copiaCCNL = { ...kpi };
    copiaCCNL[e.target.name] = e.target.value;
    setKpi(copiaCCNL);
  };
  const handleSave = async () => {
    props.saveFunction(kpi, props.id);
    handleClose();
  };

  return (
    <>
      <ButtonGroup
        variant="contained"
        aria-label="outlined primary button group"
      >
        {props.id === "edit" ? (
          <Button
            startIcon={<Add />}
            onClick={handleClickOpen}
            id={props.id}
            sx={{ color: "white", display: "none" }}
            variant="outlined"
            className="ButtonMiller"
          >
            Aggiungi
          </Button>
        ) : (
          <Button
            startIcon={<Add />}
            onClick={handleClickOpen}
            id={props.id}
            sx={{ color: "white" }}
            variant="outlined"
            className="ButtonMiller"
          >
            Aggiungi
          </Button>
        )}
      </ButtonGroup>

      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="xl"
          TransitionComponent={Transition}
        >
          {/* Title Container */}
          <DialogTitle
            sx={{
              mx: "auto",
            }}
          >
            {props.title}
          </DialogTitle>
          {/* Body Container */}
          <DialogContent>
            <Grid container mt={2} spacing={2}>
              <Grid item xs={6}>
                <TextField
                  disabled
                  value={kpi.Codice}
                  id="outlined-basic"
                  label="Codice"
                  name="Codice"
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  disabled
                  value={kpi.Descrizione}
                  id="outlined-basic"
                  label="Etichetta"
                  name="Descrizione"
                  onChange={handleChange}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  type="number"
                  value={kpi.ContrattoIndeterminato}
                  id="outlined-basic"
                  label="Contratto Indeterminato"
                  name="ContrattoIndeterminato"
                  onChange={handleChange}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                    inputProps: { min: -100, max: 100 },
                  }}
                  />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  type="number"
                  value={kpi.Dirigenti}
                  id="outlined-basic"
                  label="Dirigenti"
                  name="Dirigenti"
                  onChange={handleChange}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                    inputProps: { min: -100, max: 100 },
                  }}
                  />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  type="number"
                  value={kpi.DifferenzialeRetributivo}
                  id="outlined-basic"
                  label="Differenziale Retributivo"
                  name="DifferenzialeRetributivo"
                  onChange={handleChange}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                    inputProps: { min: -100, max: 100 },
                  }}
                />
              </Grid>
            </Grid>
            {/* Bottoni Salva & Esci */}
          </DialogContent>
          <DialogActions
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mx: 2,
            }}
          >
            <Button
              onClick={handleClose}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Close />}
            >
              Chiudi
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              className="ButtonMiller"
              startIcon={<Check />}
            >
              Salva
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};
const DeleteDialog = (props) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <IconButton aria-label="edit" onClick={handleClickOpen}>
        <Delete style={{ height: "2rem", width: "2rem", color: "#FF2768" }} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ mx: "auto" }}>
          Sei sicuro di voler eliminare il KPI selezionata?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Attenzione, sei sicuro di voler eliminare il seguente KPI :
            <br />
            <b>{props.kpi.Descrizione}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 3,
          }}
        >
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={() => props.myFunction(props.kpi.ID)}>
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
